module.exports = __webpack_public_path__ + "img/icon_nav2_active.459bde24.73a43543.svg";